import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccountUserService } from '../../service/account.service';
import { IRouteAddEdit } from './models/route-add-edit.model';
import { Observable, map } from 'rxjs';

declare var google: any;

@Injectable({
    providedIn: 'root'
})
export class RouteManagementService {
    routeUrl = "";
    user;
    activityUrl = "";
    territoryUrl = "";
    map;
    // filterMarkerLatLng = [];
    mapsDirectionRendererFlag = false;
    constructor(private http: HttpClient, private accountUserService: AccountUserService) {
        this.accountUserService.user.subscribe(x => this.user = x);
        this.activityUrl = environment.activity;
        this.territoryUrl = environment.territoryURL;
        this.routeUrl = environment.routeUrl;
    }

    setMap(map){
        this.map = map;
    }
    loadMap(){
        return this.map;
    }
    gMapsDirections(startLatLang,filterMarkerLatLng){
        this.mapsDirectionRendererFlag = true;
        //let point = new google.maps.LatLng(markerInsideDrawingList[i].point.lat, markerInsideDrawingList[i].point.lng);
        try {

            let startLatLng,destinationLatLng,waypoints;
            //let markerlatlngarr = JSON.parse(localStorage.getItem("FilteredMarkerList"));
            let directionsService = new google.maps.DirectionsService();
             let directionsRenderer = new google.maps.DirectionsRenderer();
            //let map  = routeManagementService.loadMap();
            //let map = this.map;
             directionsRenderer.setMap(this.map);
             directionsRenderer.addListener("directions_changed", () => {
              const result = directionsRenderer.getDirections();
              let total = 0;
              const myroute = result.routes[0];

              if (!myroute) {
                return;
              }

              for (let i = 0; i < myroute.legs.length; i++) {
                total += myroute.legs[i]!.distance!.value;
              }
              total = total / 1000;
              ////console.log(" total distance route[0] " + total +" Km");
            });

             if(!!startLatLang['lat'] && !!startLatLang['lng'] ){
            startLatLng = new google.maps.LatLng(startLatLang['lat'],startLatLang['lng']);
            }
            // let callDirec=this.googleMapDirectionApi;
            // callDirec();
            if(filterMarkerLatLng.length < 2)
            return;

            waypoints =[];
            for(let j=0;j<filterMarkerLatLng.length;j++){
              if(j==0 && startLatLng == undefined){
                startLatLng = filterMarkerLatLng[j];
              }else if(j == filterMarkerLatLng.length-1){
                destinationLatLng = filterMarkerLatLng[j];
              }else{
                let waypt ={
                  location: filterMarkerLatLng[j],
                  stopover: true,
                }
                waypoints.push(waypt);
              }
            }
          let request = {
            origin: startLatLng,
            destination: destinationLatLng,
            waypoints : waypoints,
            travelMode: 'DRIVING',
            //optimizeWaypoints : true
          };
          //let directionsRenderer = this.directionsRenderer;
          let mapsDirectionRendererFlag = this.mapsDirectionRendererFlag;
          directionsService.route(request, function(result, status) {
              mapsDirectionRendererFlag = false;
            if (status == 'OK') {
             // remomveFreedrawing(false);
              directionsRenderer.setDirections(result);
              ////console.log(result);
            }
          });

            } catch (error) {

            } finally{
                this.mapsDirectionRendererFlag = false;
            }
    }
    BindRouteListing(pageSize: number, pageNumber: number, options?, channelId?) {
        //let url = `${this.routeUrl}Route/details?roleId=${this.user.roleId}&pageNumber=${pageNumber}&pageSize=${pageSize}${objectNameList}`

        let url = `${this.routeUrl}Route/detailschannelwiseTerritory?pageNumber=${pageNumber}&pageSize=${pageSize}`
        if (options) {
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
            if (options.filter && options.filter.field) {
                url = `${url}&SearchValue=${options.filter.value}&SearchColumns=${options.filter.field}`;
            }
            if (options.recentFilters) {
                url = `${url}&filter=${options.recentFilters}`;
            }
        }
        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=UpdatedDate&IsAscending=false`;
        }

        if(channelId){
            url = `${url}&channelId=${channelId}`;
        }

        return this.http.get<any>(url, {
            observe: 'response'
        })
            .toPromise()
            .then(res =>
            ({
                routes: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

    BindRouteStoreLocationListing(routeId: number, territoryId: number, isUnassigned: boolean, pageSize: number, pageNumber: number, visibleColumnsVales?: string, searchValue?: string, options?:any, isView: boolean = false) {

        let url = this.routeUrl + 'Route/RouteStoreNew?routeId=' + routeId + '&territoryId=' + territoryId + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '';

        url = url+'&isUnassigned=' + isUnassigned + '&isView=' + isView + '';
        if (searchValue != null && visibleColumnsVales != null)
        url = url+'&SearchValue=' + searchValue + '&SearchColumns=' + visibleColumnsVales + '';
        if (options) {
            if (options.sort!=undefined) {
            url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }
        }

        // default sorting
        if (!options || !options.sort) {
            url = `${url}&SortBy=CreatedDate&IsAscending=false`;
        }

        return this.http.get<any>(url, {
            observe: 'response'
        }).toPromise()
            .then(res => ({
                routes: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }


    BindStoreRouteVisit(objetRefId: number, objectTypeId:number, pageSize: number, pageNumber: number, visibleColumnsVales?: string, searchValue?: string) {
        let url = this.routeUrl + 'Route/StoreRouteVisit?objetRefId=' + objetRefId + '&objectTypeId='+ objectTypeId +'&PageNumber=' + pageNumber + '&PageSize=' + pageSize + '&SortBy=CreatedDate&IsAscending=true';

        return this.http.get<any>(url, {
            observe: 'response'
        })
            .toPromise()
            .then(res => ({
                routes: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    BindDropDown(userId) {
        let url = this.territoryUrl + 'Territory?loginUserId=' + userId + '&objectNameList=territoryuser&PageNumber=0&PageSize=0&SortBy=CreatedDate&IsAscending=true';

        return this.http.get<any>(url, {
            observe: 'response'
        })
            .toPromise()
            .then(res => ({
                routes: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }

    getAllChildTerritoryies() {
        return this.http.get<any>(`${this.territoryUrl}Territory/AllChildrenTerritory`);
    }

    getAllTerritoryies(channelId: number, isActive: boolean, isAdmin: boolean = false) {
        const params = new HttpParams()
        .append("isActive", `${isActive}`)
        .append("channelId", `${channelId}`)
        .append("isAdmin", `${isAdmin}`)

        return this.http.get<any>(`${this.territoryUrl}Territory/AllTerritory`, { params: params });
    }

    getAllTerritoryiesByModule(moduleId: number, channelId: number, isActive: boolean, userId?: number) {
        let params = new HttpParams()
        .append("isActive", `${isActive}`)
        .append("channelId", `${channelId}`)
        .append("moduleId", `${moduleId}`);

        if(userId){
            params = params.append("userId", userId);
        }

        return this.http.get<any>(`${this.territoryUrl}Territory/AllTerritory`, { params: params });
    }

    getAllTerritoryiesByUser(moduleId: number, channelId: number, isActive: boolean, userId: number) {
        let params = new HttpParams()
        .append("isActive", `${isActive}`)
        .append("channelId", `${channelId}`)
        .append("moduleId", `${moduleId}`)
        .append("userId", `${userId}`);

        return this.http.get<any>(`${this.territoryUrl}Territory/AllTerritoryOfAssignedUser`, { params: params });
    }

    ReportBindDropDown(userId) {
        let url = this.territoryUrl + 'Territory/TerritoryWithName';
        return this.http.get<any>(url, {
            observe: 'response'
        })
            .toPromise()
            .then(res => ({
                routes: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination'))
            }));
    }



    getComment(objectId) {
        let headers_n = new HttpHeaders({
            "OrganizationId": this.user.organizationId + '',
            "UserId": this.user.userId + '',
            "LoginAuditId": this.user.loginAuditId + '',
            "AuthToken": this.user.token,
            "SessionId": localStorage.getItem('randomstr') + '',
            "SourceType": 'Web',
            "UserSource": this.user.userIP + ''
        });
        return this.http.get<any>(this.activityUrl + '/LionO360/2.0/API/ObjectNote?objectId=' + objectId + '&objectTypeId=6', {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    getRouteByID(routeId) {

        let headers_n = new HttpHeaders({
            "OrganizationId": this.user.organizationId + '',
            "UserId": this.user.userId + '',
            "LoginAuditId": this.user.loginAuditId + '',
            "AuthToken": this.user.token,
            "SessionId": localStorage.getItem('randomstr') + '',
            "SourceType": 'Web',
            "UserSource": this.user.userIP + ''
        });
        return this.http.get<any>(this.routeUrl + "Route/" + routeId, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }


    RouteDetailsForMap(routeId) {

        let headers_n = new HttpHeaders({
            "OrganizationId": this.user.organizationId + '',
            "UserId": this.user.userId + '',
            "LoginAuditId": this.user.loginAuditId + '',
            "AuthToken": this.user.token,
            "SessionId": localStorage.getItem('randomstr') + '',
            "SourceType": 'Web',
            "UserSource": this.user.userIP + ''
        });
        return this.http.get<any>(this.routeUrl + "Route/StoreRouteVisitView?routeId=" + routeId, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    addRoute(route) {

        let headers_n = new HttpHeaders({
            "OrganizationId": this.user.organizationId + '',
            "UserId": this.user.userId + '',
            "LoginAuditId": this.user.loginAuditId + '',
            "AuthToken": this.user.token,
            "SessionId": localStorage.getItem('randomstr') + '',
            "SourceType": 'Web',
            "UserSource": this.user.userIP + ''
        });
        return this.http.post<any>(this.routeUrl + "Route", route, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    updateRoute(route) {

        let headers_n = new HttpHeaders({
            "OrganizationId": this.user.organizationId + '',
            "UserId": this.user.userId + '',
            "LoginAuditId": this.user.loginAuditId + '',
            "AuthToken": this.user.token,
            "SessionId": localStorage.getItem('randomstr') + '',
            "SourceType": 'Web',
            "UserSource": this.user.userIP + ''
        });
        return this.http.put<any>(this.routeUrl + "Route", route, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }

    deleteRoute(routeId) {

        let headers_n = new HttpHeaders({
            "OrganizationId": this.user.organizationId + '',
            "UserId": this.user.userId + '',
            "LoginAuditId": this.user.loginAuditId + '',
            "AuthToken": this.user.token,
            "SessionId": localStorage.getItem('randomstr') + '',
            "SourceType": 'Web',
            "UserSource": this.user.userIP + ''
        });
        return this.http.delete<any>(this.routeUrl + "Route/" + routeId.id, {
            headers: headers_n
        })
            .toPromise()
            .then(res => res);
    }



    getDirectionsFromGMapAPI(startLatLng: any, destinationLatLng: any, waypoints?: any) {
        //const proxyurl = "https://cors-anywhere.herokuapp.com/";
        //debugger
        const url = "https://maps.googleapis.com/maps/api/directions/json?origin=" + startLatLng + "&destination=" + destinationLatLng + "&waypoints=" + waypoints + "&key=AIzaSyDe4eFGUfn88nHM6fDkRt_vk-vEfEohWHU&optimizeWaypoints=true";
        return this.http.get<any>(url
            // {
            //     headers: new HttpHeaders({
            //         "Access-Control-Allow-Origin": '*'
            //  })
            // }
            )
            .toPromise()
            .then(res => res);}

    // getDirectionsFromGMapAPI(startlatllng){
    //     // return this.http.get<any>("https://maps.googleapis.com/maps/api/directions/json?origin="+startLatLng+"&destination="+destinationLatLng+"&waypoints="+waypoints+"&key=AIzaSyDe4eFGUfn88nHM6fDkRt_vk-vEfEohWHU&optimizeWaypoints=true").toPromise()
    //     // .then(res => res);
    //     return null;
    // }

    // getDirectionsFromGMapAPI(obj :any, add : any ) {
    //     return this.http.get<any>('https://maps.googleapis.com/maps/api/geocode/json?address=' +add + '&key=AIzaSyDe4eFGUfn88nHM6fDkRt_vk-vEfEohWHU')
    //         .toPromise()
    //         .then((res) =>
    //             { return  {
    //                 'obj' : obj,
    //                 'res' : res
    //             }}
    //             );
    // }


    getlatlng(obj: any, add: any) {
        //removed # from address, because url string was not getting generating after #
        add = add.replace('#', '');
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${add}&key=AIzaSyDe4eFGUfn88nHM6fDkRt_vk-vEfEohWHU`;
        return this.http.get<any>(url)
            .toPromise()
            .then((res) => {
                return {
                    'obj': obj,
                    'res': res
                }
            }
            );
    }

    getRoutesByTerritories(territoryIds) {

        let headers_n = new HttpHeaders({
            "OrganizationId": this.user.organizationId + '',
            "UserId": this.user.userId + '',
            "LoginAuditId": this.user.loginAuditId + '',
            "AuthToken": this.user.token,
            "SessionId": localStorage.getItem('randomstr') + '',
            "SourceType": 'Web',
            "UserSource": this.user.userIP + ''
        });
        return this.http.get<any>(this.routeUrl + "Route/Rule/RouteList?territoryIds=" + territoryIds, {
            headers: headers_n
        });
    }

    getRouteConfigurations(){
        return this.http.get<any>( `${environment.configUrl}Configuration/ConfigurationsByModuleName?name=Route`)
    }

    routePagedListForAccount(accountData:any){
        return this.http.post<any>(`${environment.routeUrl}Route/RouteStore`, accountData)
    }

    routePagedListForLead(leadData:any){
        return this.http.post<any>(`${environment.routeUrl}Route/RouteStoreLead`, leadData)
    }

    addNewRoute(routePayload: IRouteAddEdit){
        return this.http.post<any>(`${environment.routeUrl}Route/RouteNew`, routePayload)
    }

    updateNewRoute(routePayload: IRouteAddEdit){
        return this.http.put<any>(`${environment.routeUrl}Route/RouteNew`, routePayload)
    }

    getNewRouteByID(routeId: number){
        return this.http.get<any>(`${environment.routeUrl}Route/${routeId}`)
    }


    BindNewRouteStoreLocationListing(routeId: number, territoryId: number, isUnassigned: boolean, pageSize: number, pageNumber: number, visibleColumnsVales?: string, searchValue?: string, options?: any, isView: boolean = false): Observable<any> {
        let url = this.routeUrl + 'Route/RouteStoreNew?routeId=' + routeId + '&territoryId=' + territoryId + '&PageNumber=' + pageNumber + '&PageSize=' + pageSize;

        url += '&isUnassigned=' + isUnassigned + '&isView=' + isView;
        if (searchValue != null && visibleColumnsVales != null) {
          url += '&SearchValue=' + searchValue + '&SearchColumns=' + visibleColumnsVales;
        }
        if (options && options.sort != undefined) {
          url += `&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
        } else {
          // default sorting
          url += '&SortBy=CreatedDate&IsAscending=false';
        }

        return this.http.get<any>(url, { observe: 'response' }).pipe(
          map(res => ({
            routes: res.body,
            headers: JSON.parse(res.headers.get('X-Pagination'))
          }))
        );
      }

}

